import React from 'react';
import { Box, CircularProgress, Modal } from '@mui/material';

const LoaderModal = ({ open }) => {
  return (
    <Modal
      open={open}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.2)'
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          p: 4,
          borderRadius: 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: 3
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    </Modal>
  );
};

export default LoaderModal;
